import React, { useEffect } from 'react';
import clsx from 'clsx';
import CloseBtn from '../../CloseBtn';
import { ReactComponent as IconClose } from 'images/close.svg';
import Portal from '../../Portal'
import styles from './Modal.module.scss';

type ModalProps = {
  children: React.ReactNode,
  className?: string,
  isOpen?: boolean,
  showCloseBtn?: boolean,
  circleCloseBtn?: boolean,
  zIndex?: number,
  onClose?: () => void,
  onClick?: (e?: any) => void,
  bottom?: boolean,
}

export default function Modal({
  children,
  bottom = false,
  circleCloseBtn = false,
  isOpen = false,
  showCloseBtn = true,
  className = '',
  zIndex = 900,
  onClose = () => { },
  onClick = () => { },
}: ModalProps) {
  //useEffect(() => {
  //  if (isOpen) document.body.style.overflowY = 'hidden'
  //
  //  return () => {
  //    document.body.style.overflowY = 'auto'
  //  }
  //}, [isOpen])

  if (!isOpen) {
    return null;
  }

  return (
    <Portal>
      <div className={clsx(styles.modal, bottom && styles.bottomContent)} style={{ zIndex }}>
        <div className={styles.overlay} onClick={onClose} />
        <div className={clsx(styles.content, className)} onClick={onClick}>
          {showCloseBtn && (
            circleCloseBtn ? (
              <button
                className={styles.circleClose}
                onClick={onClose}
              >
                <IconClose />
              </button>
            ) : (
              <CloseBtn
                className={styles.close}
                onClick={onClose}
                grey
              />
            )
          )}
          {children}
        </div>
      </div>
    </Portal>
  )
}
